import * as React from 'react';
import s from './table-kit.module.scss';

// LeadCell — the row identity anchor. Optional glyph (icon/swatch),
// a primary label, an optional mono sub-line, inline meta, and trailing
// affordances (e.g. a copy button). Every table's first column uses it.
export type LeadCellProps = {
  label: React.ReactNode;
  glyph?: React.ReactNode;
  sublabel?: React.ReactNode;
  meta?: React.ReactNode;
  trailing?: React.ReactNode;
  mono?: boolean;
  /** Tooltip for the label. Defaults to the label when it is a string, so
   *  truncated names stay recoverable on hover. */
  title?: string;
};

export function LeadCell({
  label,
  glyph,
  sublabel,
  meta,
  trailing,
  mono = false,
  title,
}: LeadCellProps) {
  const labelTitle = title ?? (typeof label === 'string' ? label : undefined);
  const subTitle = typeof sublabel === 'string' ? sublabel : undefined;
  return (
    <div className={s.lead}>
      {glyph != null && <span className={s.leadGlyph}>{glyph}</span>}
      <span className={s.leadText}>
        <span className={s.leadTitleRow}>
          <span
            className={[s.leadLabel, mono && s.leadLabelMono]
              .filter(Boolean)
              .join(' ')}
            title={labelTitle}
          >
            {label}
          </span>
          {meta != null && <span className={s.leadMeta}>{meta}</span>}
          {trailing != null && (
            <span className={s.leadTrailing}>{trailing}</span>
          )}
        </span>
        {sublabel != null && (
          <span className={s.leadSub} title={subTitle}>
            {sublabel}
          </span>
        )}
      </span>
    </div>
  );
}
